import { functionsBaseUrl } from '../environment';
import { callable } from '../callable';

// El token del alumno de la sesión: el servidor lo resuelve (lib/own-student).
export const calendarSubscriptionApi = {
  getMyToken: async (data: { tenantId: string }): Promise<{ token: string }> => {
    const fn = callable<typeof data, { token: string }>('getMyCalendarFeedToken');
    return (await fn(data)).data;
  },
  regenerateMyToken: async (data: { tenantId: string }): Promise<{ token: string }> => {
    const fn = callable<typeof data, { token: string }>('regenerateMyCalendarFeedToken');
    return (await fn(data)).data;
  },
};

/** Build the HTTPS URL for the iCal feed. */
export function buildIcalFeedUrl(token: string): string {
  return `${functionsBaseUrl()}/calendarFeed?t=${token}`;
}

/** webcal:// variant that triggers calendar app subscription on most platforms. */
export function buildWebcalUrl(token: string): string {
  return buildIcalFeedUrl(token).replace(/^https?:\/\//, 'webcal://');
}
